import Jumbotron from '@/components/core/Jumbotron/Jumbotron';
import { Layout } from '@/components/shared/layouts/Layout/Layout';
import { GetServerSidePropsContext, InferGetServerSidePropsType, NextPage } from 'next';
import styles from '../../styles/reset-password.module.scss';
import Section from '@/components/core/Section/Section';
import { getSafeLocale } from '@/utils/locale';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Card from '@/components/core/Card/Card';
import { ResetPasswordForm } from '@/components/shared/forms/ResetPasswordForm/ResetPasswordForm';
import { NextSeo } from 'next-seo';

type HomeProps = InferGetServerSidePropsType<typeof getServerSideProps>;

const ResetPasswordPage: NextPage<HomeProps> = () => {
	const { t } = useTranslation();

	return (
		<>
			<NextSeo title={t('password-reset')} />
			<Layout>
				<Jumbotron
					color={Jumbotron.color.PRIMARY}
					maskColor={Jumbotron.maskColor.DIMMED}
					contentClassName={styles.userPasswordResetJumbotron}
				/>
				<Section color="Dimmed">
					<Card className={styles.userPasswordResetCard} title={t('password-reset')}>
						<ResetPasswordForm />
					</Card>
				</Section>
			</Layout>
		</>
	);
};

export const getServerSideProps = async ({ locale }: GetServerSidePropsContext) => {
	return {
		props: {
			...(await serverSideTranslations(getSafeLocale(locale), ['common'])),
		},
	};
};

export default ResetPasswordPage;
